<!-- 采购订单历史 -->
<template>
    <div class='page_content'>
        <processAuditAction ref="processAuditAction"></processAuditAction>
        <subComponents ref="showSelectData"></subComponents>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line page_content_top_line1">
                <vSearch @searchData="searchData" @openSearchs="openSearch" :getRequestData=getRequestData v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform></vSearch>
                <el-tag class="tag" type="danger">总差价金额:￥{{ totalMoney }}</el-tag>
            </div>
        </div>
        <div class="page_content_center">
            <el-table v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini">
                <el-table-column label="选择操作" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                    <el-table-column align="center" v-if="tableValye.isShow == 1" :key="tableKey" :prop="tableValye.entityField" show-overflow-tooltip :min-width="tableValye.fieldWeight" :label="tableValye.showField">
                        <template slot-scope="scope">
                            <span v-if="tableValye.fieldType == 'formatter'">
                                <span v-for="(item,index) in JSON.parse(tableValye.formatterContent)" :key="index">
                                    <el-tag size="mini" v-if="scope.row[tableValye.entityField] == item.key">{{
                                    item.value }}
                                    </el-tag>
                                </span>
                            </span>
                            <span v-else-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                            </span>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                scope.row[tableValye.entityField] }}</a>
                            </span>
                            <span v-else>
                                {{ scope.row[tableValye.entityField] }}
                            </span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :smId="smId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue";
import ExtractionScheme from "../../../byComponents/ExtractionScheme.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        ExtractionScheme
    },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {
                page: 1,
                rows: 30,
                start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
                end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: []
            },
            buttonList: [],

            pageShowData: [],
            formDataList: [],
            selectedDataIndex: 0,
            selectedDetailsDataIndex: 0,
            exId: "",
            seId: "",
            ceshi: "",
            dialogTitle: "",
            seWidth: "",
            height: "",
            exTitle: "",
            seTitle: "",
            seWidth: "",
            exWidth: "",
            DialogVisible: false,
            DialogExtract: false,
            seType: '',
            smId: '',
            sField: "",
            parentSearchData: {},
            totalMoney: 0

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        'getRequestData.smName': {
            handler: function (newValue, oldValue) {
                if (newValue == '') {
                    this.getRequestData.smId = ''
                }
            },
            deep: true,
        },
        'selectedDataIndex': {
            handler: function (newValue, oldValue) {
                this.selectedDetailsDataIndex = 0
            },
            deep: true,
        }
    },
    //方法集合
    methods: {
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            //    console.log(orderId)
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
        },
        changeInputModel(val) {
            console.log(val);

            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
            // this.sendDataInfo.costChangedetailList[this.seIndex].bgmName = val.bgmName
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]

            })
        },
        getSeWidth(e) {
            console.log(e);
            this.seWidth = e + "%";
        },
        getWidth(e) {
            console.log(e);
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            console.log(e);
            this.seTitle = e;
        },
        getExtractName(e) {
            console.log(e);
            this.exTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.DialogVisible = true
            this.seId = sId
            this.sField = sField
            this.parentSearchData[type] = this.getRequestData[type]
        },
        isShowData(name, value) {
            switch (name) {
                case 'supplier':
                    var dataInfo = sessionStorage.getItem('selectSupplierData')
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo)
                        this.getRequestData.psomBuycus = dataInfo.smId
                        this.getRequestData.smName = dataInfo.smName
                    }
                    break;
            }
        },

        selectedDetailsDataAction(data) {
            var info = data.split(',').map(Number)
            this.selectedDataIndex = info[0]
        },

        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path)
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId]
            })
            if (responseData.status == 200) {
                this.pageShowData = responseData.result
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getDataList();
                this.getButtonList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },


        // 动作集合
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 1:
                    if (!this.returnData.list[this.selectedDataIndex]) {
                        this.$message({
                            message: '请先选择您要操作的数据',
                            type: 'error'
                        });
                        return false
                    }
                    var dataInfo = JSON.parse(JSON.stringify(this.returnData.list[this.selectedDataIndex]))
                    this.$refs['processAuditAction'].openBox(1, dataInfo.ccmId)
                    break;
                case 7:
                    if (this.returnData.list.length == 0) {
                        this.$message({
                            message: '暂无数据',
                            type: 'error'
                        });
                        return false
                    }
                    this.getRequestData.ormId = sessionStorage.getItem("ormId")
                    window.location.href = `${this.$store.getters.getConfig.requestUrl}/costChange/exportCostHis${this.$common.getUrl(this.getRequestData)}`
                    break;
            }
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },


        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.querCostChangeHistory(this.getRequestData)
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list
                this.returnData.pages = responseData.result.pages
                this.returnData.total = responseData.result.total
                this.returnData.pageNum = responseData.result.pageNum
                this.selectedDataIndex = 0
                this.queryMoney()
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        async queryMoney() {
            const res = await this.$http.costChangeHzMoney(this.getRequestData)
            console.log(res);
            if (res.status == 200) {
                this.totalMoney = res.result
            }

        },
        //获取状态
        getIsGsp(str, val) {
            try {
                str && str.replace(/\\/g, '')
                let arr = JSON.parse(str)
                let len = arr.length
                let newStr = ''
                for (let i = 0; i < len; i++) {
                    if (arr[i].key === val) {
                        newStr = arr[i].value
                        break;
                    }
                }
                return newStr
            } catch (ex) {
                return str
            }
        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}
.page_content_top_line {
    justify-content: space-between;
}
.tag {
    font-size: 18px;
}
</style>